import { Helmet } from "react-helmet-async";

import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Avatar,
  TextField,
  InputAdornment,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Grid,
} from "@mui/material";

// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { FetchMatchDetails } from "src/api/matchDetailsApi";
// ----------------------------------------------------------------------

const nhlQuestionTemplates = [
  { text: "PlayerA +X.5 goals", template: "player_goals" },
  { text: "PlayerA +X.5 PTS", template: "player_points" },
  { text: "PlayerA +X.5 PPG", template: "player_power_play_goals" },
  { text: "PlayerA + X.5 SHG", template: "player_short_handed_goals" },
  { text: "PlayerA + X.5 Assists", template: "player_assists" },
  { text: "PlayerA + X.5 PIM", template: "player_pim" },
  { text: "PlayerA + X.5 Takeaway", template: "player_takeaway" },
  { text: "PlayerA + X.5 Hits", template: "player_hits" },
  { text: "PlayerA + X.5 Blocks", template: "player_blocked_shots" },
  { text: "PlayerA + X.5 FO%", template: "player_face_off_pct" },
  { text: "PlayerA + X.5 Saves", template: "player_saves" },
  { text: "PlayerA + X.5 Shots", template: "player_shots_on_target" },
];
const nflQuestionTemplates = [
  { text: "PlayerA +X.5 PAS Yds", template: "player_passing_yards" },
  { text: "PlayerA +X.5 PAS TD ", template: "player_passing_touchdowns" },
  {
    text: "PlayerA +X.5 REC TD",
    template: "player_receiving_touchdowns",
  },
  { text: "PlayerA +X.5 RUS Yds", template: "player_rushing_yards" },
  { text: "PlayerA +X.5 REC Yds", template: "player_receiving_yards" },
  { text: "PlayerA +X.5 Rec", template: "player_receiving_receptions" },
  { text: "PlayerA +X.5 PAS Com", template: "player_passing_completions" },
  { text: "PlayerA +X.5 PAS Att", template: "player_passing_attempts" },
];
const questionTemplates =
  process.env.REACT_APP_LEAGUE_NAME === "nfl"
    ? nflQuestionTemplates
    : nhlQuestionTemplates;
export default function GameQuestionCreatePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [rows, setRows] = useState(null);
  const [defaultRows, setDefaultRows] = useState(null);
  const [game, setGame] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [question, setQuestion] = useState(null);
  const [questionLevels, setQuestionLevels] = useState({
    easy: true,
    medium: true,
    hard: true,
  });
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("game_id")) {
      let gameId = searchParams.get("game_id");
      setGame(gameId);
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/games`)
        .then(function (response) {
          let game = response.data.games.find(
            (game) => game.gameId === +gameId
          );
          const fetchData = async () => {
            const data = await FetchMatchDetails(game.matchId);
            let homeTeamPlayers = data[0].home_team.players.map((player) => {
              player.team_feed_id = data[0].home_team.feed_id;
              return player;
            });
            let awayTeamPlayers = data[0].away_team.players.map((player) => {
              player.team_feed_id = data[0].away_team.feed_id;
              return player;
            });
            let players = [...homeTeamPlayers, ...awayTeamPlayers];
            setRows(players);
            setDefaultRows(players);
            return data;
          };

          fetchData().catch(console.error);
        });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleGenerateQuestions = () => {
    let levels = [];
    if (questionLevels.easy) levels.push("EASY");
    if (questionLevels.medium) levels.push("MED");
    if (questionLevels.hard) levels.push("HARD");
    setLoading(true);
    let body = {
      template: question,
      player_ids: selectedRows,
      levels,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/generate-player-questions`,
        body
      )
      .then(function (response) {
        navigate(`/dashboard/game/questions?game_id=${game}`);
      });
  };
  const handleChangeSelect = (event) => {
    setQuestion(event.target.value);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };
  const requestSearch = (searchedVal) => {
    if (searchedVal.length === 0) {
      setRows([...defaultRows]);
    } else {
      const filteredRows = rows.filter((row) => {
        return (
          row.first_name.toLowerCase().includes(searchedVal.toLowerCase()) ||
          row.last_name.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setRows(filteredRows);
    }
  };
  const checkRowHandler = (e, rowId) => {
    console.log(e.target.checked);
    if (e.target.checked) {
      selectedRows.push(rowId);
      setSelectedRows([...selectedRows]);
    } else {
      let filteredRows = selectedRows.filter((item) => item !== rowId);
      setSelectedRows([...filteredRows]);
    }
  };
  const handleLevelsChange = (e) => {
    const { id } = e.target;

    setQuestionLevels((prevState) => ({
      ...prevState,
      [id]: e.target.checked,
    }));
  };
  console.log(questionLevels);
  return (
    <>
      <Helmet>
        <title> Bingo Game Questions Create </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Create Player Questions
          </Typography>
        </Stack>
        <Card style={{ marginBottom: 10 }}>
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20, marginBottom: 10 }}
          >
            <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
              <InputLabel id="demo-simple-select-label">Question</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={question}
                label="Question"
                onChange={handleChangeSelect}
              >
                {questionTemplates.map((template, index) => (
                  <MenuItem value={template.template} key={index}>
                    {template.text}
                  </MenuItem>
                ))}
              </Select>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={questionLevels.easy}
                          onChange={handleLevelsChange}
                          id="easy"
                        />
                      }
                      label="Easy"
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={questionLevels.medium}
                          onChange={handleLevelsChange}
                          id="medium"
                        />
                      }
                      label="Medium"
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={questionLevels.hard}
                          onChange={handleLevelsChange}
                          id="hard"
                        />
                      }
                      label="Hard"
                    />
                  </Grid>
                </Grid>
              </Box>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:flip-2-outline" />}
                onClick={() => handleGenerateQuestions()}
                disabled={
                  selectedRows.length === 0 ||
                  (!questionLevels.easy &&
                    !questionLevels.medium &&
                    !questionLevels.hard)
                }
              >
                Generate Team Questions
              </Button>
            </FormControl>
          </Box>
        </Card>
        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                <TextField
                  margin="dense"
                  id="kickoff"
                  label="Search"
                  type="email"
                  fullWidth
                  variant="standard"
                  onInput={(e) => {
                    requestSearch(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Iconify icon={"eva:search-outline"} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>#</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Team</TableCell>
                      <TableCell>Logo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={selectedRows.includes(row.id)}
                            onChange={(e) => checkRowHandler(e, row.id)}
                            inputProps={{
                              "aria-label": "select all desserts",
                            }}
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.first_name} {row.last_name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {process.env.REACT_APP_LEAGUE_NAME === "nhl" ? (
                            <Avatar
                              alt="Logo"
                              src={`https://www-league.nhlstatic.com/images/logos/teams-current-primary-light/${row.team_feed_id}.svg`}
                            />
                          ) : null}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {process.env.REACT_APP_LEAGUE_NAME === "nhl" ? (
                            <Avatar
                              alt="Logo"
                              src={`https://cms.nhl.bamgrid.com/images/headshots/current/168x168/${row.feed_id}.jpg`}
                            />
                          ) : null}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem sx={{ color: "error.main" }}>
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
